<template>
  <div class="documentsWrapper">
    <span class="sectionTitle">Liste des dossiers</span>
    <div class="documentsGridWrapper">
      <div class="cardLayoutWrapper cardLayoutWrapper--header">
        <div class="elem elem--span-5">
          <span>N° de dossier</span>
        </div>
        <div class="elem elem--span-5">
          <span>Dispositif</span>
        </div>
        <div class="elem elem--span-10">
          <span>Intitulé</span>
        </div>
        <div class="elem elem--span-5">
          <span>Stagiaire</span>
        </div>
      </div>
      <div
        class="gridElemWrapper"
        v-for="(elem, index) in dossiers"
        :key="index"
      >
        <div class="cardLayoutWrapper">
          <div class="elem elem--span-5">
            <span>{{ elem.code }}</span>
          </div>
          <div class="elem elem--span-5">
            <span>{{ DispositifLibelle[elem.dispositif] }}</span>
          </div>
          <div class="elem elem--span-10 elem--bold elem--nowrap">
            <span>{{ elem.intitule }}</span>
          </div>
          <div class="elem elem--span-5">
            <span>{{ stagiaires(elem.stagiaires) }}</span>
          </div>
          <div class="elem elem--span-5">
            <BasicButton
              v-if="elem.stagiaires.length > 1"
              label="Détails"
              iconRight
              size="small"
              :iconName="drawerId === index ? 'arrow-up' : 'arrow-down'"
              @click="toggleDrawer(index)"
            />
          </div>
          <div class="elem elem--span-4">
            <BasicButton
              label="Consulter"
              size="small"
              iconName="eye"
              type="secondary"
              variant="outlined"
              @click="routingService.navigateToDossierWithKey(elem.code)"
            />
          </div>
        </div>
        <div v-if="drawerId === index">
          <div class="gridElemWrapper">
            <div class="cardLayoutWrapper cardLayoutWrapper--drawer">
              <div class="elem elem--span-36">
                <span>{{ 'Stagiaires : ' + stagiairesList(elem.stagiaires) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span
        v-if="!dossiers.length"
        class="emptyListPlaceholder"
      >
        Aucun élément
      </span>
    </div>
    <div class="documentsMobileWrapper">
      <div
        class="documentsMobileElemWrapper"
        v-for="(elem, index) in dossiers"
        :key="index"
      >
        <div class="headerWrapper">
          <div class="leftContent">
            <span class="subtitle">{{ elem.code }}</span>
            <span>{{ DispositifLibelle[elem.dispositif] }}</span>
            <span>{{ elem.intitule }}</span>
            <span>{{ stagiaires(elem.stagiaires) }}</span>
          </div>
          <div class="rightContent">
            <BasicButton
              label="Consulter"
              size="small"
              iconName="eye"
              type="secondary"
              variant="outlined"
              @click="routingService.navigateToDossierWithKey(elem.code)"
            />
            <BasicButton
              v-if="elem.stagiaires.length > 1"
              label="Détails"
              iconRight
              size="small"
              :iconName="drawerId === index ? 'arrow-up' : 'arrow-down'"
              @click="toggleDrawer(index)"
            />
          </div>
        </div>
        <div
          class="bottomWrapper"
          v-if="drawerId === index"
        >
          <div class="bottomElemWrapper">
            <div class="bottomElem">
              <span>{{ 'Stagiaires : ' + stagiairesList(elem.stagiaires) }}</span>
            </div>
          </div>
        </div>
      </div>
      <span
        v-if="!dossiers.length"
        class="emptyListPlaceholder"
      >
        Aucun élément
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { ref } from 'vue'
  import type { DossierDTO } from '@/features/api/extranet/dto/Facture/DossierDTO'
  import type { StagiaireDTO } from '@/features/api/extranet/dto/Facture/StagiaireDTO'
  import { DispositifLibelle } from '@/features/domaine/types/opco'
  import { useFactureRoutingService } from '../useFactureRoutingService'

  const routingService = useFactureRoutingService()

  defineProps<{
    dossiers: DossierDTO[]
  }>()

  const stagiaires = (stagiaires: StagiaireDTO[]) => {
    if (!stagiaires || !stagiaires.length) return '-'
    const first = stagiaires[0].prenom + ' ' + stagiaires[0].nom
    const others = stagiaires.length - 1
    return first + (others > 0 ? ` + ${others}` : '')
  }

  const stagiairesList = (stagiaires: StagiaireDTO[]) => {
    if (!stagiaires || !stagiaires.length) return []

    return stagiaires
      .map((stagiaire) => {
        return (stagiaire.prenom ?? '') + ' ' + (stagiaire.nom ?? '')
      })
      .join(', ')
  }

  const drawerId = ref()
  const toggleDrawer = (id: number) => {
    if (drawerId.value === id) {
      drawerId.value = null
    } else {
      drawerId.value = id
    }
  }
</script>

<style scoped lang="less">
  @import '../../index.less';
</style>
